<template>
  <div
    v-if="checkboxOptions.length === 0"
    class="flex justify-center items-center h-full"
  >
    No Data
  </div>
  <el-checkbox-group v-else v-model="selectedValue" @change="onChange">
    <template v-for="item of checkboxOptions">
      <slot :item="item">
        <el-checkbox :key="item.key" :label="item.key">
          {{ item.value }}
        </el-checkbox>
      </slot>
    </template>
  </el-checkbox-group>
</template>

<script>
import { SmartControlMixin } from "./SmartControlMixin";

export default {
  name: "SmartCheckboxGroup",
  mixins: [SmartControlMixin],
  props: {
    clearable: { type: Boolean, default: true },
    placeholder: { type: String, default: "Please select" },
    size: { type: String, default: "default" },
    value: { type: Array, default: () => [] }, // v-model
  },
  computed: {
    checkboxOptions() {
      if (!Array.isArray(this.list)) return [];
      return this.list.map((item) => ({
        key: item.key,
        value: item.value,
        rawData: item.rawData,
      }));
    },
    selectedValue: {
      get() {
        return this.modelToKeys(this.value);
      },
      set(val) {
        this.$emit("input", this.keysToModel(val));
      },
    },
  },
  methods: {
    onChange(val) {
      const models = this.keysToModel(val);
      this.$emit("change", models);
    },
    handleClear() {
      this.selectedValue = [];
      this.$emit("input", []);
    },
    selectAll() {
      this.selectedValue = this.checkboxOptions.map((item) => item.key);
      this.$emit("change", this.keysToModel(this.selectedValue));
    },
    unselectAll() {
      this.handleClear();
    },
  },
};
</script>
